import type { Signal } from '@preact/signals-react';
import { cloneDeep } from 'lodash';
import type { ContinuousScrollerSort } from '../../continuous-scroller/continuous-scroller-types';

export class SortedFields {
  constructor(private sortedFields: Signal<Array<ContinuousScrollerSort>>) {}

  getSortedFields() {
    return this.sortedFields.value;
  }

  addSortedField(sortedField: ContinuousScrollerSort) {
    if (this.sortedFields.value.length > 0) {
      const filterIndex = this.sortedFields.value.findIndex((sort) => sort.scrollerId === sortedField.scrollerId);
      const clonedSorts = cloneDeep(this.sortedFields.value);

      if (filterIndex > -1) {
        clonedSorts.splice(filterIndex, 1, sortedField);
      } else {
        clonedSorts.push(sortedField);
      }

      this.sortedFields.value = clonedSorts;
    } else {
      this.sortedFields.value = [sortedField];
    }
  }

  removeSortedField(id: string | number) {
    if (this.sortedFields.value.findIndex((sort) => sort.scrollerId === id) > -1) {
      this.sortedFields.value = this.sortedFields.value.filter((sort) => sort.scrollerId !== id);
    }
  }

  removeAllSortedFields() {
    this.sortedFields.value = [];
  }

  setSortedFields(sorts: Array<ContinuousScrollerSort>) {
    this.sortedFields.value = sorts;
  }
}
